// extracted by mini-css-extract-plugin
var _1 = "ProfileHeader-moduledivider__MOcBr Divider-moduleDivider__dL3Vg";
var _2 = "ProfileHeader-modulephases__x7k7_ EntityPhaseList-moduleEntityPhaseList__JbnjJ";
export { _1 as "divider", _2 as "phases" }
